import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { ReliefPopup } from "./ReliefPopup";

export default function Relief() {
   const { loading, data } = useCollection("relief", ["tag", "==", "Yes"]);
   const columns = [
      {
         title: "Meters",
         dataIndex: "meters",
         align: "center",
      },
      {
         title: "Runing M",
         dataIndex: "runningMeters",
         align: "center",
      },
      {
         title: "Time Per min",
         dataIndex: "timePerMin",
         align: "center",
      },

      {
         render: (value) => <ReliefPopup meters={value.meters} id={value.id} runningMeters={value.runningMeters} timePerMin={value.timePerMin} />,
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };
   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
